import { twMerge } from "tailwind-merge";

import { Icon } from "shared/ui/icon";
import { Tooltip } from "shared/ui/tooltip";

import statisticBgUrl from "../statistic-bg.png";

type StatisticProps = {
  info?: string;
  symbol?: string;
  title: string;
  value: string;
};
export const Statistic = ({ title, info, value, symbol }: StatisticProps) => {
  return (
    <div className="relative h-[80px]">
      <div className="bg-basketBallOrange absolute top-4 left-[-4px] z-0 h-[47px] w-[8px] rounded-full" />
      <div className="border-dawnPink2 relative size-full rounded-xl border bg-white px-4 py-3 shadow-sm">
        <div className="font-inter text-pickledBluewood mb-1 flex items-center text-xs">
          {title}
          {info && (
            <Tooltip>
              <Tooltip.Trigger>
                <Icon
                  className="relative top-[-1.5px] left-[2px] size-4 cursor-pointer"
                  name="info"
                />
              </Tooltip.Trigger>
              <Tooltip.Content className="max-w-64" side="right">
                The rewards are calculated based on tokenomics and are subject
                to change
              </Tooltip.Content>
            </Tooltip>
          )}
        </div>
        <div
          className={twMerge(
            "font-ptm from-sunriseOrange to-fadedOrange bg-linear-to-tr bg-clip-text text-3xl text-transparent"
          )}
        >
          {value}
          <span className="ml-[3px] text-base">{symbol}</span>
        </div>
        <div
          className="pointer-events-none absolute right-0 bottom-0 z-20 h-[75px] w-[83px] bg-cover bg-center bg-no-repeat"
          style={{ background: `url(${statisticBgUrl})` }}
        />
      </div>
    </div>
  );
};
